import WAValidator from 'wallet-address-validator';

export default (address, currency, networkType) => {
  //做了一个中间层， 如果后期要用到库不支持的币种时，可在函数里处理。
  let convertedCurrency = currency;
  let currentSupportCoins = ['BKK', 'USDT', 'BTC', 'ETH', 'BKEX'];
  if (currentSupportCoins.indexOf(currency) === -1) return true;
  switch (currency) {
    case 'BKK':
      convertedCurrency = 'ETH';
      break;
    case 'BKEX':
      convertedCurrency = 'ETH';
      break;
    case 'USDT':
      convertedCurrency = 'BTC';
      break;
  }
  try {
    return WAValidator.validate(address, convertedCurrency, networkType);
  } catch (e) {
    //遇到不支持币种会报错， 直接认定为不合法
    return false;
  }
};
